import { cleanTimestamp } from '@gef-ui/error-report-core/utils';
import VersionDisplay from '@gef-ui/material/components/VersionDisplay';
import { passSx, sxPropType } from '@gef-ui/material/components/utils';
import { versionPropTypes } from '@gef-ui/version-info-core/constants';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { useDefaultComponentValue } from '../../utils';
const COMPONENT_NAME = 'MuiErrorMeta';
const VersionTypography = styled(Typography)(({ theme })=>({
        color: theme.palette.text.secondary
    }));
const ErrorMeta = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { screen, traceId, fe, be, timestamp, sx } = props;
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        sx: [
            {
                rowGap: 1,
                width: 'auto'
            },
            ...passSx(sx)
        ]
    }, /*#__PURE__*/ React.createElement(Grid, {
        sx: {
            mr: 2
        }
    }, /*#__PURE__*/ React.createElement(VersionTypography, null, `${screen ? `${screen} ` : ''}${cleanTimestamp(timestamp)}`)), traceId && /*#__PURE__*/ React.createElement(Grid, {
        sx: {
            mr: 2
        }
    }, /*#__PURE__*/ React.createElement(VersionTypography, null, `trace.id: ${traceId}`)), /*#__PURE__*/ React.createElement(VersionDisplay, {
        fe: fe,
        be: be
    }));
};
ErrorMeta.propTypes = {
    be: versionPropTypes,
    fe: versionPropTypes,
    screen: PropTypes.string,
    sx: sxPropType,
    timestamp: PropTypes.string.isRequired,
    traceId: PropTypes.string
};
export default ErrorMeta;
